import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
} from 'chart.js';

import { Bar, Line } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement
);

interface IProps {
  apiData: any;
  // year: number;
}
const ParetoChart = ({ apiData }: IProps) => {
  const chartData: any = {
    labels: apiData.map((item: { brekdownName: any }) => item?.brekdownName),
    datasets: [
      {
        label: 'Down Time (Hr.)',
        data: apiData.map((item: { downTime: any }) => (item.downTime/60).toFixed(2)),
        backgroundColor: 'rgba(75, 192, 192, 0.6)',
      },
      {
        label: 'Cumulative Percentage',
        data: apiData.map((item: { cummPercentage: any }) => item?.cummPercentage),
        type: 'line',
        borderColor: 'rgba(255, 99, 132, 0.6)',
        fill: false,
        yAxisID: 'y-axis-percentage',
      },
    ],
  };

  const chartOptions: any = {
    plugins: {
      maintainAspectRatio: false,
      title: {
        display: true,
        text: '',
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'BreakDown Reason',
        },
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Down Time (Hr)',
        },
      },
      'y-axis-percentage': {
        beginAtZero: true,
        position: 'right',
        title: {
          display: true,
          text: 'Cumulative Percentage',
        },
        grid: {
          display: false,
        },
        max: 100,
      },
    },
  };

  return (
    <div>
      <Bar data={chartData} options={chartOptions} />
    </div>
  );
};

export default ParetoChart;
